document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.tabs-container');
  containers.forEach((container) => {
    const tabListContainer = container.querySelector('.tablist-container');
    const tabList = tabListContainer.querySelector('.tablist-container > div');
    const tabButtons = Array.from(tabList.querySelectorAll('button'));
    const panelsContainer = container.querySelector('.tabpanels-container');
    const panels = Array.from(panelsContainer.children);

    if (tabButtons.length !== panels.length) return;

    tabList.setAttribute('role', 'tablist');

    tabButtons.forEach((btn, i) => {
      const panel = panels[i];
      const tabId = btn.id || `${container.id || 'tabs'}-tab-${i}`;
      const panelId = panel.id || `${tabId}-panel`;

      btn.id = tabId;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', panelId);

      panel.id = panelId;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tabId);

      updateSelection(0, false);
    });

    function updateSelection(index, focus = true) {
      tabButtons.forEach((btn, i) => {
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
        btn.setAttribute('tabindex', i === index ? '0' : '-1');
        btn.classList.toggle('is-open', i === index);
      });
      panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      if(focus) tabButtons[index].focus();

      const btn = tabButtons[index]; 
      if (btn && tabList && typeof tabList.scrollTo === 'function') {
        const btnCenter = btn.offsetLeft + btn.offsetWidth / 2;
        const listCenter = tabListContainer.offsetWidth / 2;
        tabListContainer.scrollTo({
          left: btnCenter - listCenter,
          behavior: 'smooth'
        });
      }

      const panel = panels[index]?.closest('.tabs-container');
      if (panel && focus) {
        const rect = panel.getBoundingClientRect();
        const root = document.documentElement;
        const headerHeight = parseInt(getComputedStyle(root).getPropertyValue('--header-height') || '0', 10);
        const adminBarHeight = parseInt(getComputedStyle(root).getPropertyValue('--wp-admin--admin-bar--height') || '0', 10);
        const fixedNavHeight = parseInt(getComputedStyle(root).getPropertyValue('--fixed-nav-height') || '0', 10);
        const offset = headerHeight + adminBarHeight + fixedNavHeight;
        const isVisible = rect.top >= offset ;

        if (!isVisible) {
          const scrollY = window.scrollY + rect.top - offset;
          window.scrollTo({ top: scrollY, behavior: 'smooth' });
        }
      }
    }

    function updateScrollClasses() {
      const canScrollX = tabListContainer.scrollWidth > tabListContainer.clientWidth;
      const canScrollY = tabListContainer.scrollHeight > tabListContainer.clientHeight;

      let notAtStart = false;
      let notAtEnd = false;

      if (canScrollX) {
        notAtStart ||= tabListContainer.scrollLeft > 0;
        notAtEnd   ||= tabListContainer.scrollLeft + tabListContainer.clientWidth < tabListContainer.scrollWidth;
      }

      if (canScrollY) {
        notAtStart ||= tabListContainer.scrollTop > 0;
        notAtEnd   ||= tabListContainer.scrollTop + tabListContainer.clientHeight < tabListContainer.scrollHeight;
      }

      tabListContainer.parentElement.classList.toggle('not-at-start', notAtStart);
      tabListContainer.parentElement.classList.toggle('not-at-end', notAtEnd);
    }
    
    updateScrollClasses();
    tabListContainer.addEventListener('scroll', updateScrollClasses);
    window.addEventListener('resize', updateScrollClasses);

    tabButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => updateSelection(i));

      btn.addEventListener('keydown', (e) => {
        let targetIndex = i;

        switch (e.key) {
          case 'ArrowRight':
            targetIndex = (i + 1) % tabButtons.length;
            e.preventDefault();
            updateSelection(targetIndex);
            break;
          case 'ArrowLeft':
            targetIndex = (i - 1 + tabButtons.length) % tabButtons.length;
            e.preventDefault();
            updateSelection(targetIndex);
            break;
          case 'Home':
            e.preventDefault();
            updateSelection(0);
            break;
          case 'End':
            e.preventDefault();
            updateSelection(tabButtons.length - 1);
            break;
        }
      });
    });
  });
});
